import { render } from "./order.vue?vue&type=template&id=38c9aa12&scoped=true&ts=true"
import script from "./order.vue?vue&type=script&lang=ts"
export * from "./order.vue?vue&type=script&lang=ts"

import "./order.vue?vue&type=style&index=0&id=38c9aa12&scoped=scoped&lang=css"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c9aa12"]])

export default __exports__